import { Icon } from '@doordash/design-language'
import * as DA from '../../../typeModules/events'
import t from './strings'
import { ItemType } from './types'

const { whyDoorDash, signUpDetails, howToDash, faq, learnMore } = t

export enum HamburgerItems {
  WhyDoorDash = 'WhyDoorDash',
  SignUpDetails = 'SignUpDetails',
  HowToDash = 'HowToDash',
  FAQ = 'FAQ',
}

export const DesktopNavItems = {
  faq: 'FAQ',
  learnMore: 'LearnMore',
  signUpForm: 'SignUpForm',
}

export const getHamburgerItem = (item: HamburgerItems): ItemType => {
  switch (item) {
    case HamburgerItems.WhyDoorDash:
      return {
        icon: Icon.Types.LogoDoordash,
        text: whyDoorDash(),
        anchor: '#whydoordash',
        trackingId: DA.HeaderNames.MenuOptionWhyDoorDash,
      }
    case HamburgerItems.SignUpDetails:
      return {
        icon: Icon.Types.MenuEditLine,
        text: signUpDetails(),
        anchor: '#signupdetails',
        trackingId: DA.HeaderNames.MenuOptionSignUpDetails,
      }
    case HamburgerItems.HowToDash:
      return {
        icon: Icon.Types.DevicePhone,
        text: howToDash(),
        anchor: '#howtodash',
        trackingId: DA.HeaderNames.MenuOptionHowToDash,
      }
    case HamburgerItems.FAQ:
      return {
        icon: Icon.Types.HelpCircleLine,
        text: faq(),
        anchor: '#faq',
        trackingId: DA.HeaderNames.MenuOptionFAQ,
      }
    default:
      return {
        icon: null,
        text: '',
        anchor: '#',
        trackingId: null,
      }
  }
}

export const getDesktopNavItem = (item: string): ItemType => {
  switch (item) {
    case DesktopNavItems.faq:
      return getHamburgerItem(HamburgerItems.FAQ)
    case DesktopNavItems.signUpForm:
      return {
        icon: null,
        text: '',
        anchor: '#signupform',
        trackingId: DA.HeaderNames.MenuOptionSignUp,
      }
    case DesktopNavItems.learnMore:
      return {
        icon: null,
        text: learnMore(),
        anchor: '#signupdetails',
        trackingId: DA.HeaderNames.MenuOptionLearnMore,
      }
    default:
      return {
        icon: null,
        text: '',
        anchor: '#',
        trackingId: null,
      }
  }
}

export const hamburgerItemList = () => {
  const result = []

  Object.keys(HamburgerItems).map(item => {
    const myItem: HamburgerItems = HamburgerItems[item] as HamburgerItems
    result.push(getHamburgerItem(myItem))
  })

  return result
}
